import img70 from './EquipoMedico/img70.jpg'
import { Footer } from './Footer'
import React, { Component } from 'react'
import { Card, Row, Col, Container } from 'react-bootstrap'
import { Navigation } from './Navigation'

export class Intensivo extends Component {
    render() {
        return (
            <div>
                <Navigation />
                <Container fluid className="px-5">
                    <br />
                    <Row>
                        <Col className="text-center">
                            <h1>Intensivo</h1>
                        </Col>
                    </Row>
                    <br />

                    {/* Reutilizamos el contenedor centrado (8 de 12 columnas) */}
                    <Row className="justify-content-center">
                        <Col xs={12} md={10} lg={8}>
                            <Card className="shadow border-0 text-center">
                                <Card.Body className="p-3">
                                    <Card.Img 
                                        variant="top" 
                                        src={img70} 
                                        style={{ 
                                            width: '100%', 
                                            height: 'auto', 
                                            maxHeight: '800px', 
                                            objectFit: 'contain' 
                                        }} 
                                    />
                                </Card.Body>
                                <Card.Footer className="bg-white border-0">
                                    <Card.Title style={{ fontSize: '1.8rem', padding: '10px' }}>
                                        Cuidados Intensivos
                                    </Card.Title>
                                </Card.Footer>
                            </Card>
                        </Col>
                    </Row>
                    <br />
                </Container>
                <Footer />
            </div>
        )
    }
}